// Field rules shared by the two live "What the Lead Sees" previews —
// thank_you_step_controller (onboarding step 6) and thank_you_preview_controller
// (the order form, #14347) — so the phone tolerance and the image-file check
// cannot drift between them.

export const US_PHONE_DIGITS = 10

// Digits only; an 11-digit number with a leading US country code is a 10-digit
// number (same tolerance as PhoneNormalizer.normalize).
export function phoneDigits(raw) {
  let digits = (raw || "").replace(/\D/g, "")
  if (digits.length === US_PHONE_DIGITS + 1 && digits.startsWith("1")) digits = digits.slice(1)
  return digits
}

export function phoneComplete(raw) {
  return phoneDigits(raw).length === US_PHONE_DIGITS
}

// "(916) 908-0466" for a complete US number; otherwise exactly what was typed,
// so a partial number still echoes in the card while it counts as missing.
export function formattedPhone(raw) {
  const digits = phoneDigits(raw)
  if (digits.length === US_PHONE_DIGITS) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }
  return raw || ""
}

// Mirrors photo_crop_controller's acceptedTypes default: what a slot enforces
// when the page carries no photo-crop-accepted-types-value to read.
export const DEFAULT_ACCEPTED_PHOTO_TYPES = "image/jpeg,image/png,image/heic,image/heif"
export const PHOTO_CROP_SLOT = '[data-controller~="photo-crop"]'

// The accepted list of a photo-crop slot element (its
// photo-crop-accepted-types-value), or photo-crop's default when the caller
// found no slot. `accept` on the input only filters the picker — a GIF or
// WebP chosen via "All Files" is refused by photo-crop#validateFile with its
// own type error and CLEARED without re-firing change, so a preview that
// counted it would show a photo the slot never attaches. Each surface locates
// its slot: the onboarding step looks down from its root, the order-form
// card walks up from the photo input it reads by id.
export function acceptedPhotoTypes(slot) {
  const list = slot?.dataset?.photoCropAcceptedTypesValue || DEFAULT_ACCEPTED_PHOTO_TYPES
  return list.split(",").map((type) => type.trim()).filter(Boolean)
}

// Mirrors photo_crop_controller#validateFile: an accepted MIME type — the
// caller's list, or any image/* when none is given — or a .heic/.heif filename,
// because iPhone HEIC files sometimes report an empty type.
export function isImageFile(file, acceptedTypes = null) {
  if (!file) return false
  if (/\.hei[cf]$/i.test(file.name || "")) return true
  if (typeof file.type !== "string") return false
  return acceptedTypes ? acceptedTypes.includes(file.type) : file.type.startsWith("image/")
}
